angular.module('invoice')
    .controller('InvoiceSubstantiveDescriptionEditController', function ($q, data, toastr, $rootScope, $uibModalInstance, modals, Invoice, InvoiceService, InvoiceConst, AgreementService, FilesSimpleUploadService, InvoiceWorkflow) {
        this.InvoiceService = InvoiceService
        let zeros = {totalNet: 0, totalVat: 0, totalGross: 0}

        this.$onInit = () => {
            this.configurationLoaded = false
            this.item = angular.copy(data)
            this.item.costs = this.item.costs || []
            $q.all([
                Invoice.get({id: data.id}).$promise,
                InvoiceWorkflow.load()
            ]).then(([invoice, configuration]) => {
                this.invoice = invoice
                this.substantiveDescriptionConfiguration = configuration.substantiveDescription
                this.costsConfiguration = configuration.costs
                this.agreementOrAssignmentConfiguration = configuration.agreementOrAssignment
                this.agreementOrAssignmentLimit = configuration.agreementOrAssignment.bypassBelowGross[invoice.currency]
                this.transitionAfterSave = configuration.substantiveDescription.transitionAfterSave
                this.configurationLoaded = true
            })
            this.editingCostDescriptionIndex = null
            this.recalculateTotals()
        }
        this.recalculateTotals = () => {
            this.totalCosts = InvoiceService.sum(this.item.costs.map(cost => cost.price))
        }
        this.uploadAssignment = () => {
            FilesSimpleUploadService.openCustom({url: "/crm/api/file-association-invoice/" + this.item.id + "/assignment", formData: {id: this.item.id}}).then(result => {
                if(!angular.isArray(result) || result.length !== 1){
                    toastr.error("Nie udało się przesłać pliku")
                    return
                }
                let file = result[0];
                this.item.substantiveDescription = this.item.substantiveDescription || {}
                this.item.substantiveDescription.assignment = {
                    file: file,
                    type: file.type,
                    uuid: file.uuid
                }
                delete this.item.substantiveDescription.noAssignment
            })
        }
        this.selectAgreement = () => {
            AgreementService.select({type: 'AGREEMENT', status: ['ACTIVE']}).then(agreement => {
                this.item.substantiveDescription = this.item.substantiveDescription || {}
                this.item.substantiveDescription.agreement = agreement
                this.item.substantiveDescription.noAssignment = true
                delete this.item.substantiveDescription.assignment
            })
        }
        this.deleteAgreement = () => {
            delete this.item.substantiveDescription.agreement
            delete this.item.substantiveDescription.noAgreement
            delete this.item.substantiveDescription.comment
        }
        this.selectAssignment = () => {
            AgreementService.select({type: 'ORDER'}, {linkableOrderStatuses: this.agreementOrAssignmentConfiguration.linkableOrderStatuses}).then(assignment => {
                this.item.substantiveDescription = this.item.substantiveDescription || {}
                this.item.substantiveDescription.assignment = assignment
                this.item.substantiveDescription.noAgreement = true
                delete this.item.substantiveDescription.noAssignment
                delete this.item.substantiveDescription.agreement
            })
        }
        this.deleteAssignment = () => {
            delete this.item.substantiveDescription.assignment
            delete this.item.substantiveDescription.noAssignment
            delete this.item.substantiveDescription.assignmentComment
        }
        this.addCost = () => {
            let costs = InvoiceService.sum(this.item.costs.map((cost) => cost.price))
            let total = this.invoice.pricing || zeros
            let totalLeft = {
                totalNet: InvoiceService.sub(total.totalNet, costs.totalNet),
                totalVat: InvoiceService.sub(total.totalVat, costs.totalVat),
                totalGross: InvoiceService.sub(total.totalGross, costs.totalGross)
            }
            let itemCost = {
                price: {
                    totalNet: totalLeft.totalNet,
                    totalVat: totalLeft.totalVat,
                    totalGross: totalLeft.totalGross
                },
                percentage: InvoiceService.percentage(totalLeft.totalNet, total.totalNet) || 0
            }
            let data = {
                item: itemCost,
                document: this.invoice,
                total: total,
                costs: costs,
                totalLeft: totalLeft
            }
            return modals.open('app/invoice/substantive-description-edit-cost-modal.html', 'InvoiceCostController', data, {size: 'sm'}, "$ctrl").then(result => {
                this.item.costs.push(result)
                this.recalculateTotals()
            })
        }
        this.removeCost = index => {
            this.item.costs.splice(index, 1)
            this.recalculateTotals()
        }

        this.editCost = (cost, index) => {
            let data = {
                item: angular.copy(cost),
                document: this.invoice
            }
            return modals.open('app/invoice/substantive-description-edit-cost-modal.html', 'InvoiceCostController', data, {size: 'sm'}, "$ctrl").then(result => {
                this.item.costs[index] = result
                this.recalculateTotals()
            })
        }
        this.editCostDescription = index => {
            this.editingCostDescriptionIndex = index
        }
        this.closeCostDescriptionEditor = () => {
            this.editingCostDescriptionIndex = null
        }
        this.isEditingCostDescription = index => this.editingCostDescriptionIndex === index
        this.isAgreementOrAssignmentRequired = () => {
            let description = this.item && this.item.substantiveDescription
            let grossAmount = this.invoice && this.invoice.pricing && this.invoice.pricing.totalGross
            if (!this.agreementOrAssignmentConfiguration || !this.agreementOrAssignmentConfiguration.enabled) {
                return false
            }
            let bypassLimit = this.agreementOrAssignmentLimit
            let requirementApplies = bypassLimit == null || bypassLimit < 0 || grossAmount == null || Math.abs(grossAmount) >= bypassLimit
            if (!requirementApplies) return false
            return !description
                || (description.agreement == null && description.assignment == null)
        }
        this.shouldTransitionAfterSave = () => this.transitionAfterSave
            && this.substantiveDescriptionConfiguration
            && this.substantiveDescriptionConfiguration.enabled
            && this.transitionAfterSave.enabled
            && this.invoice
            && this.invoice.status === this.transitionAfterSave.fromStatus
        this.agreementOrAssignmentRequiredMessage = () => {
            let currency = this.invoice && this.invoice.currency
            let bypassLimit = this.agreementOrAssignmentLimit
            if (bypassLimit == null || bypassLimit < 0) return `Dla dokumentu w walucie ${currency} wymagana jest umowa albo zlecenie.`
            return `Dla dokumentu o wartości brutto co najmniej ${bypassLimit.toLocaleString('pl-PL')} ${currency} wymagana jest umowa albo zlecenie.`
        }
        this.duplicateCost = (costLineEntity) => {
            let costLine = angular.copy(costLineEntity)
            let costs = InvoiceService.sum(this.item.costs.map((cost) => cost.price))
            let total = this.invoice.pricing || zeros
            let totalLeft = {
                totalNet: InvoiceService.sub(total.totalNet, costs.totalNet),
                totalVat: InvoiceService.sub(total.totalVat, costs.totalVat),
                totalGross: InvoiceService.sub(total.totalGross, costs.totalGross)
            }
            let itemCost = {
                billingStartDate: costLine.billingStartDate,
                billingEndDate: costLine.billingEndDate,
                project: costLine.project,
                category: costLine.category,
                costCenter: costLine.costCenter,
                costType: costLine.costType,
                description: costLine.description,
                comment: costLine.comment,
                price: costLine.price
            }
            let data = {
                item: itemCost,
                document: this.invoice,
                total: total,
                costs: costs,
                totalLeft: totalLeft
            }
            return modals.open('app/invoice/substantive-description-edit-cost-modal.html', 'InvoiceCostController', data, {size: 'sm'}, "$ctrl").then(result => {
                this.item.costs.push(result)
                this.recalculateTotals()
            })
        }
        this.importKsefPositions = () => {
            return Invoice.ksefCosts({id: this.item.id}).$promise.then(result => {
                if (!result || result.length === 0) {
                    toastr.warning("Brak pozycji do zaimportowania z XML KSeF")
                    return
                }
                return modals.open('app/invoice/substantive-description-ksef-import-modal.html', 'InvoiceSubstantiveDescriptionKsefImportController', {
                    costs: result,
                    existingCosts: this.item.costs
                }, {size: 'lg'}, "$ctrl").then(importResult => {
                    if (!importResult || !importResult.costs || importResult.costs.length === 0) {
                        return
                    }
                    if (importResult.replaceExisting) {
                        this.item.costs = importResult.costs
                    } else {
                        this.item.costs = this.item.costs.concat(importResult.costs)
                    }
                    this.recalculateTotals()
                    toastr.success("Zaimportowano pozycje z XML KSeF")
                })
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            if (!this.configurationLoaded) {
                return
            }
            if (this.isAgreementOrAssignmentRequired()) {
                toastr.error(this.agreementOrAssignmentRequiredMessage())
                return
            }
            return Invoice.saveSubstantiveDescription(this.item).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast(InvoiceConst.eventUpdate)
                })
        }
    })
    .controller('InvoiceSubstantiveDescriptionKsefImportController', function ($uibModalInstance, data) {
        this.$onInit = () => {
            this.costs = angular.copy(data.costs || [])
            this.existingCosts = angular.copy(data.existingCosts || [])
            this.form = {
                replaceExisting: false,
                category: getSingleValue(this.existingCosts, cost => cost.category),
                project: getSingleValue(this.existingCosts, cost => cost.project),
                costCenter: getSingleValue(this.existingCosts, cost => cost.costCenter),
                costType: getSingleValue(this.existingCosts, cost => cost.costType),
                billingStartDate: getSingleValue(this.existingCosts, cost => cost.billingStartDate),
                billingEndDate: getSingleValue(this.existingCosts, cost => cost.billingEndDate)
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            $uibModalInstance.close({
                replaceExisting: this.form.replaceExisting,
                costs: this.costs.map(cost => ({
                    price: angular.copy(cost.price),
                    description: cost.description,
                    comment: cost.comment,
                    category: angular.copy(this.form.category),
                    project: angular.copy(this.form.project),
                    costCenter: angular.copy(this.form.costCenter),
                    costType: angular.copy(this.form.costType),
                    billingStartDate: this.form.billingStartDate,
                    billingEndDate: this.form.billingEndDate
                }))
            })
        }

        function getSingleValue(items, getter) {
            if (!items || items.length === 0) {
                return null
            }
            let values = items.map(getter).filter(value => value != null)
            if (values.length === 0) {
                return null
            }
            let first = values[0]
            let firstId = first && first.id != null ? first.id : first
            let isSingle = values.every(value => {
                let valueId = value && value.id != null ? value.id : value
                return angular.equals(valueId, firstId)
            })
            return isSingle ? angular.copy(first) : null
        }
    })
